<template>
	<div>
		<Card title="被保人信息">
			<Form :label-width="150" class="mt15">
				<Row>
					<Col span="12">
						<FormItem label="被保险人：">
							{{insuredList.subjectName}}
						</FormItem>
					</Col>
				</Row>
			</Form>
		</Card>
	  </div>
	</template>
	<script>
	export default {
		props:{
			info:{
				type:Object,
				default(){
					return {}
				}
			},
			type:{
				type:String,
				default(){
					return ''
				}
			},
		},
		data(){
			return {
				modal:false
			}
		},
		computed:{
			insuredList(){
				return (this.info.insuredList&&this.info.insuredList.length>0)?this.info.insuredList[0]: {}
			}
		},
		methods:{
		}
	}
	</script>
	


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/common/InsuredPersonInfo.vue